export default {
  title: 'Disponibilités de réservation',
};
